import type { FaireProductEntity } from "../../entity_types/product";

export const p_v4vdn3vm9p: FaireProductEntity = {
  token: "p_v4vdn3vm9p",
  type: "product",
  name: "Heirloom Tomato Candle - Red",
  brandToken: "b_z57zpn8vpm",
  brandName: "Scandles",
  imageUrl:
    "https://cdn.faire.com/fastly/18af310c7ed0c727a950b8d587c950d9d575fd42e0a5a5460ced145c22a54fe5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3c30700083ef623ad1dbced224e5bcd4cd616eeb489decf1a2f823436c55c022.jpeg",
    "https://cdn.faire.com/fastly/778a4e4f3f95abb727e205a236fa2a2356b79466b2c698b620644325abff291c.jpeg",
    "https://cdn.faire.com/fastly/b3f89ce12a5332427df9d6ab2565526da7b3d3bb53b6817801cf89b94d5c92c0.jpeg",
    "https://cdn.faire.com/fastly/cb968f422ddf709e2db0495ed4a14524b89577595711f83f23985eb0769fb7d5.jpeg",
    "https://cdn.faire.com/fastly/d4df68e8c205648371c319b8de72e253affe1ff5191b1cd413171e94774b04d9.jpeg",
    "https://cdn.faire.com/fastly/1195c0a2ad7d870437c66b6fcba5ccfe748d6a0dc7b8950cac8995aa52a43928.jpeg",
    "https://cdn.faire.com/fastly/0fd9dc19f7eb6b5f3160b8406eb967b55051244d1cbed348bd9e7d5b4ad2679c.jpeg",
    "https://cdn.faire.com/fastly/ccb4783c7245d9181a10896923eac26ac60293857dfb2c2228ac4cd43621e694.jpeg",
    "https://cdn.faire.com/fastly/88301c7eefdd6c64badc8217582a9f9278d36f1d168ac4d8f9c1f5410ca381ba.jpeg",
  ],
  priceDollars: 16.8,
  description:
    "Plucked straight from the scandles vine, our Heirloom Tomato candles might be one our favorites yet! Beautifully molded off the real thing and smelling of tomato leaves, you’d be a fool to passata up on these cuties!\n\nDimensions H: 2.25” W: 3.25” D: 3”\nMade from Natural Soy Wax\n\nThese candles are hand-poured and made with 100% natural soy wax and scented with essential oils. Each candle is handmade so color, scent, and appearance may vary slightly and may have cosmetic imperfections left by the hands of those who created them.\n\nOur candles are designed for a decorative purpose. If you do choose to light them, please place on a heatproof dish to collect the wax and do not leave unattended..\n",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:49.217Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
